import {SODeleteSimpleAttributePermissionRule} from '../../core/simple-attribute-permission-rule/so-delete-simple-attribute-permission-rule';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteSimpleAttributePermissionRule extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteSimpleAttributePermissionRule;
}